module.exports = __webpack_public_path__ + "img/home.d87184d.png";